import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'

import { ConversationService } from '@forwardflow/services/ConversationService'
import useSWR from 'swr'

export function useGetCallTranscript(id: number) {
   const response = useSWR([QUERY_KEYS.GET_CALL_TRANSCRIPT, id], () =>
      ConversationService.getCallTranscript(id)
   )
   return {
      ...response,
   }
}
